<template>
  <div class="point-modal-wrap" v-if="!shouldHideForAbTreatment">
    <div class="point-modal">
      <div class="point-modal-ttl">
        <div class="point-modal-ttl__icon">
          <img
            src="/travelist/sp/img/icon/point_icon_new.png"
            alt="point_icon"
          />
        </div>
        <p class="point-modal-ttl__txt">ポイントとは</p>
      </div>
      <p class="point-modal-text">
        会員登録すると、航空券購入時に金額に応じたポイントがゲットできます！付与されたポイントは次回のお買い物から利用できます。
      </p>
      <p class="point-modal-img">
        <img
          src="/travelist/pc/banner/banner_point_2.jpg?20231206"
          alt="アプリで会員登録すると初回購入から利用できるポイント500円分プレゼント"
        />
      </p>
      <div class="info-exchange">
        <p class="info-exchange__txt">
          トラベリストポイントは<br />外部ポイントへ交換できます！
        </p>
        <div class="info-exchange__box">
          <div class="info-exchange__t-point">
            <img
              class="info-exchange__t-point-img"
              src="/travelist/sp/img/icon/point_icon_new.png"
              alt="point_icon"
            />
            <p class="info-exchange__t-point-text">
              トラベリスト<br />ポイント
            </p>
          </div>
          <i class="info-exchange__arrow fa-solid fa-caret-right"></i>
          <div class="info-exchange__logos">
            <img
              class="info-exchange__logo info-exchange__logo--1"
              src="/travelist/sp/img/icon/paypay_icon.jpg"
              alt="paypayポイント"
            />
            <img
              class="info-exchange__logo info-exchange__logo--2"
              src="/travelist/sp/img/icon/rakuten_icon.png"
              alt="楽天ポイント"
            />
          </div>
        </div>
      </div>
      <div class="pc-only">
        <p
          class="point-modal-btn point-modal-btn--1"
          v-show="!isShowQR"
          @click="showQR"
        >
          {{ btnText1 }}
        </p>
      </div>
      <div class="sp-only">
        <a
          class="point-modal-btn point-modal-btn--2"
          :href="headerOneLinkURL"
          >{{ btnText1 }}</a
        >
      </div>
      <p class="point-modal-qr" v-show="isShowQR">
        <img src="/images/common/app_qr_code.png" alt="QRコード" />
      </p>
      <p class="point-modal-text text-center" v-show="isShowQR">
        上記QRコードをお手持ちのスマートフォンのカメラからスキャンして、<br />トラベリストアプリをインストールしてください。
      </p>
      <a class="point-modal-btn point-modal-btn--3" href="/s/member/register">{{
        btnText2
      }}</a>
      <a class="point-modal-btn point-modal-btn--4" href="/login">{{
        btnText3
      }}</a>
      <div class="point-modal-arrow"></div>
    </div>
    <div class="point-overlay" @click="closePointModal"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createOneLinkUrl, PIDS } from '../../src_common/constants/Appsflyer';
import AbTreatmentMixin from '../mixins/AbTreatmentMixin';
export default {
  mixins: [AbTreatmentMixin],
  data() {
    return {
      btnText1: 'アプリインストール',
      btnText2: '会員登録',
      btnText3: 'ログイン',
      isShowQR: false,
    };
  },
  methods: {
    getCurrentPid() {
      // HeaderPointModalはweb_header_modal PIDを使用
      return 'web_header_modal';
    },
    closePointModal() {
      this.$emit('closePointModal');
    },
    showQR() {
      this.isShowQR = true;
    },
  },
  computed: {
    ...mapGetters(['quotedMedia']),
    headerOneLinkURL() {
      // 見積もりと申込で送る med_id が一致した媒体だけを使う (MED-1517)
      const media = this.quotedMedia ? this.quotedMedia.med_id : null;
      const linkURL = createOneLinkUrl(PIDS.web_header_modal, '', media);
      return linkURL;
    },
  },
};
</script>

<style lang="scss" scoped>
.sp-only {
  display: none;
  .sp & {
    display: block;
  }
}
.pc-only {
  display: none;
  .pc & {
    display: block;
  }
}
.point-modal {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  background: #fff;
  z-index: 125;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  .sp & {
    width: 95%;
    top: 60px;
  }
}
.point-modal-ttl {
  display: flex;
  align-items: center;
  &__icon {
    width: 20px;
    margin-right: 4px;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
  &__txt {
    font-size: 16px;
    font-weight: bold;
  }
}
.point-modal-text {
  font-size: 14px;
  margin-top: 10px;
  .sp & {
    font-size: 13px;
  }
}
.point-modal-img {
  margin: 20px auto 0;
  width: 90%;
  img {
    width: 100%;
    vertical-align: bottom;
  }
  .sp & {
    width: 100%;
  }
}
.point-modal-btn {
  background-color: #ff9b3e;
  border-radius: 4px;
  width: 60%;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto 0;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.4));
  transition: all 0.5s;
  cursor: pointer;
  .sp & {
    width: 80%;
    height: 40px;
    margin-top: 15px;
  }
}

.point-modal-qr {
  width: 150px;
  margin: 20px auto 0;
  img {
    width: 100%;
  }
}

.point-modal-arrow {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-right: 11px solid transparent;
  border-left: 11px solid transparent;
  border-bottom: 18px solid #fff;
  border-top: 0;
  .sp & {
    left: auto;
    right: 70px;
  }
}
.point-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 124;
}

.info-paypay {
  display: flex;
  width: 70%;
  margin: 20px auto 0;
  align-items: center;
  justify-content: center;
  .sp & {
    width: 90%;
  }
  &__img {
    width: 70px;
    margin-right: 20px;
    .sp & {
      width: 50px;
      margin-right: 10px;
    }
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
  &__txt {
    font-size: 18px;
    font-weight: bold;
    .sp & {
      font-size: 13px;
    }
  }
}
.note-paypay {
  font-size: 11px;
  margin-top: 5px;
  text-align: center;
  br {
    .pc & {
      display: none;
    }
  }
}

.info-exchange {
  display: flex;
  flex-direction: column;
  width: 70%;
  margin: 20px auto 0;
  align-items: center;
  justify-content: center;
  text-align: center;
  .sp & {
    width: 90%;
  }
  &__box {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 10px;
  }
  &__txt {
    font-size: 18px;
    font-weight: bold;
    .sp & {
      font-size: 13px;
    }
  }
  &__t-point {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
  &__t-point-img {
    width: 22px;
  }
  &__t-point-text {
    font-size: 10px;
    line-height: 1.1;
  }
  &__arrow {
    font-size: 30px;
  }
  &__logos {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  &__logo {
    width: 30px;
    &--1 {
      width: 37px;
    }
  }
}
</style>
